import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '@env';
import { LinkResolveResponse } from '@shared/models';

import { BackendService } from '../backend.service';

/**
 * Resolves the short token in a branded customer link (`<link base>/<slug>/<token>`) to the
 * flow it opens. The token is the authoritative part of such a link; the slug before it is
 * cosmetic and is not sent to the API.
 */
@Injectable({
  providedIn: 'root',
})
export class LinkTokenService {
  private backendService = inject(BackendService);

  /**
   * Errors with the value `ErrorInterceptor` produced: the API answers 404 when the token is
   * unknown or malformed, but a maintenance window or a 5xx surfaces here too, so callers have
   * to tell a dead link apart from a backend that is merely unavailable.
   */
  resolve(token: string): Observable<LinkResolveResponse> {
    return this.backendService.get<LinkResolveResponse>(`${environment.linxLinksEndpoint}/${encodeURIComponent(token)}`);
  }
}
